import { getProviderType, getUserInfo } from "@/utils/user";

export default {
  inserted(el, binding) {
    const { value } = binding;
    let providerType = getProviderType();
    let userInfo = getUserInfo();
    if (value && value instanceof Array && value.length > 0) {
      const permissionRoles = value;

      // const hasPermission = permissions.some(permission => {
      //   return permissionRoles.includes(permission.name);
      // });
      const userId = userInfo.userId;

      // 权限配置中： 如果权限数组包含供应商类型并且权限数组中不存在改供应商的userId  --- 则通过
      const hasPermission =
        permissionRoles.includes(providerType) &&
        !permissionRoles.includes(userId);
      if (!hasPermission) {
        if (el.nodeName === "BUTTON" || el.nodeName === "A") {
          el.parentNode && el.parentNode.removeChild(el);
        } else {
          const childNode = el.childNodes;
          el.parentNode && el.parentNode.removeChild(el);
          // childNode.forEach(item => {
          //   if (item.nodeName === "INPUT") {
          //     item.setAttribute("disabled", "true");
          //   } else {
          //     item.parentNode && item.parentNode.removeChild(item);
          //   }
          // });
        }
      }
    }
  },
};
